import { AppState } from '../../index';

export function orderDetailSelector(state:AppState){
   return state.accountOrdersDetail;
}